{
  "name": "claro",
  "version": "2.0.44",
  "eSignature": {
    "requiredVersion": "2.3.4",
    "recommendedVersion": "2.3.7",
    "signingExtensionName": "eParakstsTokenSigning"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 192.168.0.127",
    "build": "ng run claro:build:test-env",
    "build:prod": "ng run claro:build:production",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.7",
    "@angular/cdk": "^20.1.6",
    "@angular/common": "^20.1.7",
    "@angular/compiler": "^20.1.7",
    "@angular/core": "^20.1.7",
    "@angular/forms": "^20.1.7",
    "@angular/platform-browser": "^20.1.7",
    "@angular/platform-browser-dynamic": "^20.1.7",
    "@angular/router": "^20.1.7",
    "@ant-design/icons-angular": "^20.0.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@ctrl/tinycolor": "^4.1.0",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@fullcalendar/angular": "^7.0.2",
    "@kolkov/angular-editor": "^3.0.0-beta.2",
    "@microsoft/signalr": "^9.0.6",
    "apexcharts": "^5.3.3",
    "date-fns": "^4.1.0",
    "file-saver": "^2.0.5",
    "fullcalendar": "^7.0.2",
    "html2canvas": "^1.4.1",
    "known-css-properties": "^0.37.0",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ng-apexcharts": "^2.0.0",
    "ng-zorro-antd": "^20.1.2",
    "ngx-device-detector": "^10.0.2",
    "ol": "^10.6.1",
    "ol-layerswitcher": "^4.1.2",
    "proj4": "^2.19.10",
    "rxjs": "^7.8.2",
    "sanitize-html": "^2.17.0",
    "temporal-polyfill": "^1.0.3",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/schematics": "^20.1.1",
    "@angular/build": "^20.1.6",
    "@angular/cli": "^20.1.6",
    "@angular/compiler-cli": "^20.1.7",
    "@angular/language-service": "^20.1.7",
    "@types/node": "^24.3.0",
    "less": "^4.4.0",
    "nz-tslint-rules": "^0.901.2",
    "prettier": "^3.6.2",
    "ts-node": "^10.9.2",
    "typescript": "^5.8.3"
  }
}
